import {RouteDefinition} from '../../../routes';
import {ControlTypeListScreen} from './ControlTypeListScreen';
import {ControlTypeEditScreen} from './ControlTypeEditScreen';

export const ControlTypeSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/developer/control-type',
        component: ControlTypeListScreen,
    },
    {
        routerLink: '/developer/control-type/edit',
        component: ControlTypeEditScreen,
    },
    {
        routerLink: '/developer/control-type/edit/:id',
        component: ControlTypeEditScreen,
    },
];
